import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  page: {
    padding: theme.spacing(4)
  },
  pageTitle: {
    marginBottom: theme.spacing(3)
  },
  messageContainer: {
    display: 'flex'
  },
  messageCard: {
    width: '100%',
    // Warm off-white surface (not pure white) on the beige page, with a soft shadow and no hard
    // border — matches the design's empty/error card composition.
    backgroundColor: theme.colorPalette.beige_25,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.04)',
    padding: theme.spacing(8)
  },
  messageContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(4)
  },
  messageIcon: {
    width: 40,
    height: 48
  },
  messageHeader: {
    color: theme.colorPalette.green_75
  },
  messageText: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5)
  },
  // Let the body copy run the full card width (matching the design) rather than wrapping early.
  messageBody: {
    display: 'block'
  },
  messageDivider: {
    width: '100%',
    height: 1,
    backgroundColor: theme.colorPalette.beige_75
  },
  messageHint: {
    display: 'block',
    fontSize: 13,
    color: theme.colorPalette.green_80
  },
  backButton: {
    marginTop: theme.spacing(1)
  }
}));
